'use client';

export { default } from './Fade';


//////////////////
// WEBPACK FOOTER
// ../@mui/material/Fade/index.js
// module id = 277
// module chunks = 22